import { Flex, Layout, Space } from "antd"
import { useTranslation } from "react-i18next"
import { Text } from "../Text"
import { getCurrentYear } from "../../utils/date"
import { APP_CREATOR, APP_CREATOR_URL } from "../../constants"

const AntFooter = Layout.Footer

export const Footer: React.FC = () => {
  const { t } = useTranslation()
  return (
    <AntFooter>
      <Flex justify="center" align="middle">
        <Space size="small">
          <Text>{`© ${getCurrentYear()} ${t("footer.madeBy")}`}</Text>
          <Text type="link" target="_blank" href={APP_CREATOR_URL}>
            {APP_CREATOR}
          </Text>
        </Space>
      </Flex>
    </AntFooter>
  )
}
